import styles from "./InformationSecurityPolicyPage.module.css";

const InformationSecurityPolicyPage = () => {
  return (
    <div className={styles.container}>
      <h2>ΠΟΛΙΤΙΚΗ ΑΣΦΑΛΕΙΑΣ ΠΛΗΡΟΦΟΡΙΩΝ</h2>

      <p>
        Η εταιρεία THE RECORDS HUB S.A. εφαρμόζει Σύστημα Διαχείρισης Ασφάλειας
        Πληροφοριών σύμφωνα με τις απαιτήσεις του προτύπου ISO/IEC 27001:2022,
        το οποίο είναι πλήρως ενσωματωμένο στις επιχειρησιακές της διαδικασίες.
      </p>

      <p>
        Το Σύστημα Διαχείρισης Ασφάλειας Πληροφοριών καλύπτει τις παρακάτω
        υπηρεσίες της εταιρείας:
      </p>
      <ul>
        <li>
          ΠΑΡΟΧΗ ΥΠΗΡΕΣΙΩΝ ΓΙΑ ΤΗΝ ΑΣΦΑΛΗ ΨΗΦΙΟΠΟΙΗΣΗ, ΑΣΦΑΛΗ ΦΥΛΑΞΗ, ΑΣΦΑΛΗ
          ΚΑΤΑΣΤΡΟΦΗ ΚΑΙ ΑΣΦΑΛΗ ΔΙΑΧΕΙΡΙΣΗ ΑΡΧΕΙΩΝ ΠΕΛΑΤΩΝ ΤΗΣ ΕΤΑΙΡΕΙΑΣ ΣΕ
          ΕΝΤΥΠΗ Η/ΚΑΙ ΗΛΕΚΤΡΟΝΙΚΗ ΜΟΡΦΗ.
        </li>
        <li>
          ΠΑΡΟΧΗ ΣΥΜΒΟΥΛΕΥΤΙΚΩΝ ΥΠΗΡΕΣΙΩΝ ΓΙΑ ΤΗΝ ΑΣΦΑΛΗ ΔΙΑΧΕΙΡΙΣΗ ΑΡΧΕΙΩΝ
        </li>
        <li>ΣΥΜΒΟΥΛΕΥΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ GDPR/DPO</li>
      </ul>

      <p>
        Η Διοίκηση διασφαλίζει ότι η παρούσα πολιτική ευθυγραμμίζεται με τον
        στρατηγικό προσανατολισμό της εταιρείας και παρέχει το κατάλληλο πλαίσιο
        για τη θέσπιση και ανασκόπηση στόχων ασφάλειας πληροφοριών. Η πολιτική
        αυτή υποστηρίζεται από πόρους, μηχανισμούς επικοινωνίας, εσωτερική
        διανομή, και είναι διαθέσιμη στα ενδιαφερόμενα μέρη, σύμφωνα με τις
        απαιτήσεις του ISO/IEC 27001:2022
      </p>

      <p>
        Συγκεκριμένοι στόχοι της εταιρείας για την ασφάλεια πληροφοριών
        περιλαμβάνουν:
      </p>
      <ul>
        <li>
          Προστασία της ακεραιότητας των πληροφοριών από μη εξουσιοδοτημένη
          τροποποίηση ή καταστροφή.
        </li>
        <li>
          Διασφάλιση της εμπιστευτικότητας των πληροφοριών από μη
          εξουσιοδοτημένη πρόσβαση.
        </li>
        <li>
          Διατήρηση της διαθεσιμότητας των πληροφοριών για την ομαλή λειτουργία
          των δραστηριοτήτων της εταιρείας.
        </li>
        <li>
          Πλήρης συμμόρφωση με νομικές, κανονιστικές και συμβατικές απαιτήσεις
          σχετικά με την ασφάλεια πληροφοριών.
        </li>
        <li>
          Ασφάλεια των προσωπικών δεδομένων και των πληροφοριακών υποδομών της
          εταιρείας.
        </li>
        <li>
          Συνεχής ευαισθητοποίηση και εκπαίδευση της διοίκησης και του
          προσωπικού σε θέματα ασφάλειας πληροφοριών.
        </li>
        <li>
          Καταγραφή, αναφορά και διερεύνηση παραβάσεων και περιστατικών
          ασφάλειας πληροφοριών.
        </li>
        <li>
          Λήψη και εφαρμογή μέτρων πρόληψης και αποκατάστασης για περιστατικά
          ασφάλειας.
        </li>
        <li>
          Παρακολούθηση των εξελίξεων στον τομέα της τεχνολογίας και της
          ασφάλειας για την ικανοποίηση των απαιτήσεων των ενδιαφερόμενων μερών.
        </li>
        <li>
          Διαρκής βελτίωση του Συστήματος Διαχείρισης Ασφάλειας Πληροφοριών.
        </li>
      </ul>
    </div>
  );
};

export default InformationSecurityPolicyPage;
